export default __webpack_public_path__ + "static/media/PurchaseLinkIndicatorPaymentActive.079c003c.svg";